import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "wdw-news-project-preview" }
const _hoisted_2 = {
  key: 0,
  class: "pt-1"
}
const _hoisted_3 = { class: "mb-2 d-flex" }
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_preview_thought = _resolveComponent("preview-thought")!
  const _component_vue_loading = _resolveComponent("vue-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.errorMsg.content !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Message, {
            severity: $setup.errorMsg.severity,
            closeable: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.errorMsg.content), 1)
            ]),
            _: 1
          }, 8, ["severity"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (!$setup.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.thoughts, (thought) => {
              return (_openBlock(), _createElementBlock("div", {
                key: thought.id,
                class: "col-sm-4"
              }, [
                _createVNode(_component_preview_thought, {
                  thought: thought,
                  thoughtListHeight: $props.thoughtListHeight,
                  moreLink: $props.moreLink
                }, null, 8, ["thought", "thoughtListHeight", "moreLink"])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary d-flex m-auto",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.redirectToAllThoughts && $setup.redirectToAllThoughts(...args)))
              }, "mehr")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_vue_loading, { loadingMessage: "News werden geladen" })
          ]))
    ])
  ]))
}